export default __webpack_public_path__ + "static/media/kids.e572c686.png";